<div class="product-add-to-cart">
    <nb-actions class="quantity-selector">
            <nb-action  icon="minus-square-outline" pack="eva"title="Decrease"></nb-action>
            <nb-action title="Quantity">{{quantity}}</nb-action>
            <nb-action  icon="plus-square-outline" pack="eva"title="Increase"></nb-action>
    </nb-actions>
    <!-- <div class="quantity-selector">
        <div class="decrease">
            <i class="fa fa-minus" aria-hidden="true"></i>
        </div>
        <div class="current-quantity">1</div>
        <div class="increase">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
    </div> -->
    <div class="add-to-cart">
        <button nbButton size="small" status="primary">Add To Cart</button>
    </div>
</div>
